@if (this.router.url === '/accueil' && this.userService.isProprietaire(logementCourant$|async)) {
  @if (this.router.url === '/accueil' && this.userService.isProprietaire(logementCourant$|async)) {
    <a routerLink="/mes-logements/modifier/{{logementCourantId}}">
      <div class="cover" [ngClass]="{'shadow': shadow}" [style.backgroundImage]=" image ? 'url(' + image + ')' : ''">
        @if (title || subtitle) {
          <div class="cartouche">
            <h2 class="mb-4">{{title}}</h2>
            <h3>{{ subtitle }}</h3>
          </div>
        }
        <div class="overlay" #contentWrapper [ngClass]="{'d-none' : !hasContent}">
          <ng-content></ng-content>
        </div>
      </div>
    </a>
  }
} @else {
  <div class="cover" [ngClass]="{'shadow': shadow}" [style.backgroundImage]=" image ? 'url(' + image + ')' : ''">
    @if (title || subtitle) {
      <div class="cartouche">
        <h2 class="mb-4">{{title}}</h2>
        <h3>{{ subtitle }}</h3>
      </div>
    }
    <div class="overlay" #contentWrapper [ngClass]="{'d-none' : !hasContent}">
      <ng-content></ng-content>
    </div>
  </div>
}
